export default __webpack_public_path__ + "static/media/p2p.f380805f.png";